import CustomIcon from "@/components/ui/custom-icon";
import S from "./index.module.scss";
import { FC } from "react";
import Link from "next/link";
import clsx from "clsx";
import { GetCatalogResourceData } from "@/api/generated-api";
import Picture from "@/components/ui/picture";
import { formattedPrice } from "@/utils/formatters";

interface ICatalogItem {
  item: GetCatalogResourceData;
  variant?: "default" | "catalog";
}

const CatalogCard: FC<ICatalogItem> = ({ item, variant = "default" }) => {
  const isCatalogMode = variant === "catalog";

  return (
    <Link href={`/catalog/${item.id}`} className={clsx(S.card, isCatalogMode && S.cardCatalog)}>
      <Picture image={item.picture} alt={item.name} width={550} height={650} className={S.cardImageWrap} />

      <div className={S.cardContent}>
        <h3 className={S.cardTitle}>{item.name}</h3>
        <p className={S.cardDescription}>{item.short_description}</p>
      </div>

      <div className={S.cardFooter}>
        <div className={S.sizes}>
          {(item?.sizes ?? []).map(size => (
            <span key={size.id} className={S.sizeChip}>
              {size.title}
            </span>
          ))}
        </div>
        <div className={S.priceRow}>
          <span className={S.price}>{formattedPrice(item.price ?? 0)}</span>
          <span className={S.explore}>
            <span>Исследовать</span>
            <CustomIcon fileName="icon-chevron" className={S.exploreIcon} />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CatalogCard;
